import { Component, OnInit, Input } from '@angular/core';
import { ReservationSubItem, Reservation } from 'src/app/model/reservation.model';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { BooleanPipe } from 'src/app/pipes/boolean-pipe';
import { TranslationPipe } from 'src/app/pipes/translation.pipe';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { DataService } from 'src/app/service/data.service';
import { Pricelist } from 'src/app/model/pricelist';

@Component({
  selector: 'app-reservation-items',
  templateUrl: './reservation-items.component.html',
  styleUrls: ['./reservation-items.component.css']
})
export class ReservationItemsComponent implements OnInit {
  @Input() reservation: Reservation;
  @Input() reservationSubItems: ReservationSubItem[];
  @Input() process = false;

  reservationItemsTableColumns: any[];
 
  constructor(
    private router: Router,
    private datePipe: DatePipe,
    private booleanPipe: BooleanPipe,
    private translationPipe: TranslationPipe,
    private dataService: DataService) {}

    equipmentTypes : Pricelist[];

  ngOnInit() {
    this.dataService.getEquipmentTypesByGroupType(0).subscribe(data => {
      this.equipmentTypes = data as Pricelist[];
      this.initReservationItemsTable();
    });


  }

  initReservationItemsTable() {
    if(this.reservation.isLessonReservation==1){
    this.reservationItemsTableColumns = [
      { field: 'name', header: 'lblResItemsName' },
      { field: 'lastName', header: 'lblResItemsLastName' },
      { field: 'age', header: 'lblResItemsAge' },
      { field: 'sportType', header: 'lblResItemsSport' },
      { field: 'skillLevel', header: 'lblResItemsSkillLevel' },
      { field: 'lessonType', header: 'lblResItemsLessonType' },
      { field: 'note', header: 'lblResItemsNote' },
      { field: 'isWithMeal', header: 'lblResItemsMeal' },
      { field: 'isWithGear', header: 'lblResItemsGear' },
      { field: 'numberOfClassesIndivid', header: 'lblResItemsNumberOfDays' }
    ]
  }
  else{
    this.reservationItemsTableColumns = [
      { field: 'name', header: 'lblResItemsName' },
      { field: 'lastName', header: 'lblResItemsLastName' },
      { field: 'age', header: 'lblResItemsAge' },   
      { field: 'skillLevel', header: 'lblResItemsSkillLevel' },
      { field: 'groupType', header: 'lblGroupType' },
      { field: 'numberOfDays', header: 'lblPriceListNumberOfDays' },
      { field: 'equipment', header: 'lblRentEquipmentReservation' },
      { field: 'height', header: 'lblHeight' },
      { field: 'weight', header: 'lblWeight' },
      { field: 'place', header: 'lblPlace' }
    ]
  }
  }

  get reservationItemsTableData() {
    if (this.reservationSubItems) {
      if(this.reservation.isLessonReservation==1){
      return this.reservationSubItems.map(r => ({
        id: r.id,
        name: r.name,
        lastName: r.lastName,
        age: r.age,
        sportType: r.sportType.description,
        skillLevel: this.translationPipe.transform(r.skillLevel.description),
        lessonType: this.translationPipe.transform(r.lessonType.description),
        note: r.note,
        isWithMeal: this.booleanPipe.transform(r.isWithMeal),
        isWithGear: this.booleanPipe.transform(r.isWithGear),
        numberOfClassesIndivid: r.numberOfClassesIndivid,
      }));
    }
    else{    
      return this.reservationSubItems.map(r => ({
        id: r.id,
        name: r.name,
        lastName: r.lastName,
        age: r.age,
        skillLevel: this.translationPipe.transform(r.skillLevel.description),
        groupType: this.translationPipe.transform(r.groupType.description),
        numberOfDays: r.numberOfDays,
        equipment: this.translationPipe.transform(this.equipmentTypes.filter(x=>x.name==r.equipment).map(x=>x.description)[0]),
        height: r.height,
        weight: r.weight,
        place: r.place,
      }));   
    }
    } else {
      return [];
    }
  }

  processItem(rowData) {
    const reservationSubItem = this.reservationSubItems.find(i => i.id === rowData.id);

      this.router.navigateByUrl('/schedule', { state: { reservationSubItem:reservationSubItem} });

  }
}
